// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__isPyf","head":"Table_head__3vwW5","col":"Table_col__T1n5D"};